import { X, ArrowRight } from 'lucide-react';
import { useBodyScrollLock } from '../hooks/useBodyScrollLock';

export default function TaskLinkPickerModal({ isOpen, blockTitle, candidates = [], onClose, onSelect }) {
  useBodyScrollLock(isOpen);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 overflow-y-auto" style={{ background: 'var(--pd-overlay)', backdropFilter: 'blur(6px)' }}>
      <div className="flex min-h-full items-center justify-center px-4 py-8" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="w-full max-w-[420px] rounded-[28px] overflow-hidden animate-fade-in" style={{ background: 'var(--pd-popover)', border: '1px solid var(--pd-popover-border)', boxShadow: 'var(--pd-shadow-3)' }}>
        <div className="flex items-start justify-between gap-4 px-5 py-4" style={{ borderBottom: '1px solid var(--pd-border)' }}>
          <div>
            <div className="text-[10px] uppercase tracking-[0.12em] font-semibold" style={{ color: 'var(--pd-subtle)' }}>Linked task choice</div>
            <h3 className="text-[18px] font-semibold mt-2" style={{ color: 'var(--pd-text)', letterSpacing: '-0.04em' }}>Pick the exact task for “{blockTitle}”</h3>
          </div>
          <button data-testid="task-link-picker-close" onClick={onClose} className="pd-icon-button" style={{ width: 38, height: 38 }}><X className="w-4 h-4" /></button>
        </div>
        <div className="px-4 py-4 space-y-2 max-h-[360px] overflow-y-auto custom-scrollbar">
          {candidates.map((task) => (
            <button key={task.id} data-testid={`task-link-choice-${task.id}`} onClick={() => onSelect(task)} className="w-full text-left rounded-2xl px-4 py-3 flex items-center justify-between gap-3 transition-colors" style={{ background: 'var(--pd-panel-2)', border: '1px solid var(--pd-border)' }}>
              <div>
                <div className="text-[13px] font-semibold" style={{ color: 'var(--pd-text)' }}>{task.title}</div>
                <div className="text-[11px] mt-1" style={{ color: 'var(--pd-subtle)' }}>{task.priority} · {task.estimatedMinutes || 30}m</div>
              </div>
              <ArrowRight className="w-4 h-4" style={{ color: 'var(--pd-focus)' }} />
            </button>
          ))}
        </div>
      </div>
      </div>
    </div>
  );
}
